import { memo } from 'react';
import { XYCoord } from 'react-dnd';

import styled from '@mint-lib/styled';

import { Icon, Input, NumberField } from '@myn/mui';

import { DECIMAL_SCALE } from '../../EditModal.constants.js';

type Props = {
  name: string;
  currentOffset: XYCoord;
  isNumericOption: boolean;
};

const CustomOptionLayer = ({ name, currentOffset, isNumericOption }: Props) => {
  return (
    <DraggableItem currentOffset={currentOffset}>
      {isNumericOption ? (
        <NumberField
          value={name ? Number(name) : null}
          maxDecimals={DECIMAL_SCALE}
          restFormatProps={{
            minDecimals: DECIMAL_SCALE,
          }}
          InputProps={{
            startAdornment: <Icon component="Draggable" />,
            endAdornment: <Icon component="Close" />,
          }}
          size="small"
          fullWidth
        />
      ) : (
        <Input
          value={name}
          startAdornment={<Icon component="Draggable" />}
          endAdornment={<Icon component="Close" />}
          size="small"
          fullWidth
        />
      )}
    </DraggableItem>
  );
};

const DraggableItem = styled('div')<{ currentOffset: XYCoord }>`
  overflow: hidden;
  position: relative;
  top: ${({ currentOffset }) => `${currentOffset.y - 10}px`};
  left: ${({ currentOffset }) => `${currentOffset.x + 2}px`};
  width: 304px;
  filter: drop-shadow(16px 16px 10px rgba(0, 0, 0, 0.16));
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
`;

export default memo(CustomOptionLayer);
